import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface ServiceCardProps {
  id?: string | number;
  title: string;
  description: string;
  icon: string;
  image: string;
  alt: string;
  href: string;
}

const ServiceCard = ({ id, title, description, icon, image, alt, href }: ServiceCardProps) => {
  // Create unique key for Link component to prevent duplicate key warnings
  const linkKey = id ? `service-link-${id}-${href}` : undefined;
  
  return (
    <Link href={href} key={linkKey} className="group block">
      <div className="bg-card rounded-xl overflow-hidden shadow-soft hover:shadow-elevated transition-all duration-base card-hover">
        <div className="relative h-48 overflow-hidden">
          <AppImage
            src={image}
            alt={alt}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-base"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent"></div>
          <div className="absolute bottom-4 left-4">
            <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
              <Icon name={icon as any} size={24} variant="solid" className="text-slate-800" />
            </div>
          </div>
        </div>
        
        <div className="p-6 space-y-3">
          <h3 className="text-xl font-headline font-bold text-text-primary group-hover:text-primary transition-colors duration-base">
            {title}
          </h3>
          <p className="text-text-secondary font-body leading-relaxed">
            {description}
          </p>
          <div className="flex items-center space-x-2 text-primary font-body font-semibold pt-2">
            <span>Learn More</span>
            <Icon name="ArrowRightIcon" size={20} variant="outline" className="group-hover:translate-x-1 transition-transform duration-base" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;